<template>
  <b-modal :visible="isModalActive" :title="$t('Sync Members')" :ok-title="$t('Submit')" :cancel-title="$t('Cancel')"
    ok-variant="primary" cancel-variant="outline-secondary" @ok="handleSubmit" @hidden="resetForm"
    @change="(val) => $emit('update:is-modal-active', val)">
    <validation-observer ref="formObserver" #default="{ handleSubmit }">
      <b-form @submit.prevent="handleSubmit(onSubmit)">
        <!-- LDAP -->
        <validation-provider #default="validationContext" name="LDAP" rules="required">
          <b-form-group :label="$t('Register Number')" label-for="ldap">
            <b-form-input id="ldap" v-model="syncData.ldap" :state="getValidationState(validationContext)" trim
              :placeholder="$t('Enter Register Number')" />
            <b-form-invalid-feedback>
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>

        <!-- Password -->
        <validation-provider #default="validationContext" name="Password" rules="required">
          <b-form-group :label="$t('Password')" label-for="password">
            <b-form-input id="password" v-model="syncData.password" type="password"
              :state="getValidationState(validationContext)" trim :placeholder="$t('Enter Password')" />
            <b-form-invalid-feedback>
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import {
  BModal,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
} from 'bootstrap-vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { ref } from '@vue/composition-api';
import { required } from '@validations';
import formValidation from '@core/comp-functions/forms/form-validation';
import { useToast } from 'vue-toastification/composition';
import ToastificationContent from '@core/components/toastification/ToastificationContent';
import store from '@/store';

export default {
  name: 'SyncMembersModal',
  components: {
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    ValidationProvider,
    ValidationObserver,
    ToastificationContent,
  },
  model: {
    prop: 'isModalActive',
    event: 'update:is-modal-active',
  },
  props: {
    isModalActive: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, { emit }) {
    const toast = useToast();

    const blankSyncData = {
      ldap: '',
      password: '',
    };

    const syncData = ref(JSON.parse(JSON.stringify(blankSyncData)));

    const resetSyncData = () => {
      syncData.value = JSON.parse(JSON.stringify(blankSyncData));
    };

    const {
      refFormObserver: formObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetSyncData);

    const handleSubmit = (bvModalEvt) => {
      // Prevent modal from closing
      bvModalEvt.preventDefault();

      // Trigger form validation
      formObserver.value.validate().then(success => {
        if (!success) {
          return;
        }

        onSubmit();
      });
    };

    const onSubmit = () => {
      // Prepare data for API call
      const requestData = {
        username: syncData.value.ldap,
        password: syncData.value.password,
      };

      console.log('Syncing members with:', requestData);

      // API call to sync members with LDAP credentials
      store.dispatch('apps-members/syncMembers', requestData)
        .then(() => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Success syncing members',
              icon: 'CheckIcon',
              variant: 'success',
            },
          });
          emit('update:is-modal-active', false);
          emit('refetch-data');
          resetSyncData();
        })
        .catch(() => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error syncing members',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          });
        });
    };

    return {
      syncData,
      formObserver,
      getValidationState,
      resetForm,
      handleSubmit,
      onSubmit,
      required,
    };
  },
};
</script>

<style scoped></style>
